import cn from 'clsx'
import { Box } from '@/components/Box/Box'
import { getClassNames, type ResponsiveProp } from '@/utils/responsiveProps'

import css from './TextureCard.module.css'

import type { BoxProps } from '@/components/Box/Box'

export interface TextureCardProps extends BoxProps {
    children: React.ReactNode
    variant?: 'teal' | 'sunray'
    insetBlockStart?: ResponsiveProp<'0' | '16' | '20'>
    insetBlockEnd?: ResponsiveProp<'0' | '16' | '20'>
    insetInlineStart?: ResponsiveProp<'0' | '16' | '20'>
    insetInlineEnd?: ResponsiveProp<'0' | '16' | '20'>
    className?: string
}

export function TextureCard({
    children,
    variant = 'teal',
    insetBlockStart,
    insetBlockEnd,
    insetInlineStart,
    insetInlineEnd,
    className,
    ...rest
}: TextureCardProps) {
    const insetBlockStartClassNames = getClassNames(css, 'insetBlockStart', insetBlockStart)
    const insetBlockEndClassNames = getClassNames(css, 'insetBlockEnd', insetBlockEnd)
    const insetInlineStartClassNames = getClassNames(css, 'insetInlineStart', insetInlineStart)
    const insetInlineEndClassNames = getClassNames(css, 'insetInlineEnd', insetInlineEnd)

    return (
        <Box
            className={cn(
                css.textureCard,
                insetBlockStartClassNames,
                insetBlockEndClassNames,
                insetInlineStartClassNames,
                insetInlineEndClassNames,
                {
                    [css.textureCardTeal]: variant === 'teal',
                    [css.textureCardSunray]: variant === 'sunray',
                },
                className,
            )}
            {...rest}
        >
            <div className={css.inner}>{children}</div>
        </Box>
    )
}
